import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Snackbars from 'bit/mobiauto.web-ui-components.components.snackbars/Snackbars';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { ReactComponent as Mobiauto } from 'assets/mobiauto.svg';
import ActionCreators from 'modules/resale/store/reducers/ui/actionCreators';
import { Creators as proposalCreators } from 'modules/resale/store/ducks/proposal';
import routesPath from 'config/routesPath';
import HypertextButton from 'modules/financing/components/atoms/HypertextButton';
import styled from 'styled-components';

const ContainerNotification = styled.div`
  background: #00b0aa;
  border-radius: 4px;
  padding: 8px 12px;
  display: none;
  &[data-is-visible='true'] {
    display: flex;
  }
`;

const LeftContainer = styled.div`
  border-right: 1px solid #ffffff69;
  padding-right: 16px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  padding-left: 8px;
`;

const CenterContainer = styled.div`
  color: #fff;
  line-height: 20px;

  & .notification-title {
    font-size: 14px;
    font-family: 'Poppins Medium';
  }
`;

const RightContainer = styled.div`
  border-left: 1px solid #ffffff69;
  padding-left: 8px;
  margin-left: 8px;
  display: flex;
  align-items: center;
`;

const SnackbarComponent = () => {
  const { snackbar }: any = useSelector(({ UI }: any) => UI);
  const { currentDealer }: any = useSelector(
    ({ dealerStore }: any) => dealerStore
  );

  const dispatch = useDispatch();

  const handleClose = (event = null, reason = null) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(ActionCreators.snackbarManagement(null, '', false));
  };

  const handleClickOpenProposal = (dealerId, proposalId) => {
    if (dealerId !== currentDealer.id) {
      window.location.href = `${routesPath.getRecursivePath(
        routesPath.proposals,
        {
          dealerId,
        }
      )}?tab=1&proposalId=${proposalId}`;
      return;
    }
    dispatch(
      proposalCreators.setProposalModalOpen(true, {
        dealerId,
        proposalId,
      })
    );
    handleClose();
  };

  return (
    <>
      {snackbar.variant === 'PROPOSAL_RECEIVED' ? (
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={snackbar.open}
          autoHideDuration={snackbar.autoHideDuration}
          onClose={handleClose}
          message=""
          TransitionComponent={props => <Slide {...props} direction="left" />}
        >
          <ContainerNotification data-is-visible={snackbar.open}>
            <LeftContainer>
              <Mobiauto />
            </LeftContainer>
            <CenterContainer>
              <div className="notification-title">{snackbar.data?.title}</div>
              <div>{snackbar.data?.message}</div>
              <div style={{ display: 'flex' }}>
                <HypertextButton
                  onClick={() =>
                    handleClickOpenProposal(
                      snackbar.data?.dealerId,
                      snackbar.data?.proposalId
                    )
                  }
                >
                  Abrir proposta
                </HypertextButton>
              </div>
            </CenterContainer>
            <RightContainer>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon fontSize="small" style={{ color: '#fff' }} />
              </IconButton>
            </RightContainer>
          </ContainerNotification>
        </Snackbar>
      ) : (
        <Snackbars
          variant={snackbar.variant}
          message={snackbar.message}
          open={snackbar.open}
          onClose={handleClose}
          autoHideDuration={snackbar.autoHideDuration}
          vertical="bottom"
          horizontal="right"
        />
      )}
    </>
  );
};

export default SnackbarComponent;
